export enum EPermission {
	contacts = "contacts",
	conversations = "conversations",
	groups = "groups",
	users = "users",
	sites = "sites",
	parameters = "parameters",
	retrocession = "retrocession"
}